var _defs, _rect, _path, _g, _clipPath, _g2, _path2, _g3, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStainedGlass(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 400 320",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sg-bg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FBF5EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F5EAD4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sg-arch",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#D06E76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#9E2430"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sg-gold",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#DDB65C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#AD8720"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 320,
    fill: "url(#sg-bg)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 280 V140 A90 90 0 0 1 240 140 V280 Z",
    fill: "none",
    stroke: "url(#sg-gold)",
    strokeWidth: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#archClip)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "archClip",
    d: "M65 278 V140 A85 85 0 0 1 235 140 V278 Z",
    fill: "#fff"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "archClipPath"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65 278 V140 A85 85 0 0 1 235 140 V278 Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#archClipPath)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 130,
    width: 180,
    height: 160,
    fill: "#E7F3F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65 278 L150 190 L235 278 Z",
    fill: "#BFE0DD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 185,
    r: 42,
    fill: "#D06E76",
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 185,
    r: 24,
    fill: "#DDB65C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65 140 L150 210 L235 140",
    stroke: "#AD8720",
    strokeWidth: 4,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108 278 L150 210 L192 278",
    stroke: "#AD8720",
    strokeWidth: 4,
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 150,
    y1: 60,
    x2: 150,
    y2: 280,
    stroke: "#AD8720",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: 210,
    x2: 240,
    y2: 210,
    stroke: "#AD8720",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65 140 A85 85 0 0 1 235 140",
    fill: "none",
    stroke: "#AD8720",
    strokeWidth: 4
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60 280 V140 A90 90 0 0 1 240 140 V280 Z",
    fill: "none",
    stroke: "url(#sg-gold)",
    strokeWidth: 10
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M300 70 l6 16 16 6 -16 6 -6 16 -6 -16 -16 -6 16 -6 z",
    fill: "#DDB65C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330 130 l4 10 10 4 -10 4 -4 10 -4 -10 -10 -4 10 -4 z",
    fill: "#D06E76"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 308,
    textAnchor: "middle",
    fontFamily: "Georgia, serif",
    fontSize: 14,
    fill: "#4E3F37",
    letterSpacing: 1
  }, "Stained &amp; Leaded Glass")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStainedGlass);
export default __webpack_public_path__ + "static/media/stained-glass.25a6e32faedb219649ee3c9882b1dfb6.svg";
export { ForwardRef as ReactComponent };